<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label for="equipment">Equipment</label>
                    @if (useEquipmentPicker) {
                        <wj-combo-box
                            id="equipment"
                            name="equipment"
                            [(ngModel)]="target.equipment"
                            [itemsSource]="equipmentOptions"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                            required
                        ></wj-combo-box>
                    } @else {
                        <input id="equipment" type="text" class="form-control" [(ngModel)]="target.equipment" name="equipment" required />
                    }
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label for="axleNumber">Axle #</label>
                    <input
                        id="axleNumber"
                        type="number"
                        min="1"
                        class="form-control"
                        [(ngModel)]="target.axleNumber"
                        name="axleNumber"
                        required
                    />
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label for="side">Side</label>
                    <wj-combo-box
                        id="side"
                        [(ngModel)]="target.side"
                        name="side"
                        [itemsSource]="sideOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        required
                    ></wj-combo-box>
                </div>
            </div>
        </div>
        <div class="form-group">
            <label for="tireSize">Tire size</label>
            <input id="tireSize" type="text" class="form-control" [(ngModel)]="target.tireSize" name="tireSize" required />
        </div>
        <div class="form-group">
            <label for="positionLabel">Position label (optional)</label>
            <input id="positionLabel" type="text" class="form-control" [(ngModel)]="target.positionLabel" name="positionLabel" />
        </div>
        <div class="form-group">
            <label for="configNotes">Notes</label>
            <textarea id="configNotes" class="form-control" rows="2" [(ngModel)]="target.notes" name="notes"></textarea>
        </div>
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
